import React from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { FieldDeviceDeploymentRingList } from "./FieldDeviceDeploymentRingList";

interface FieldDeviceDeploymentRingsProps {
  device: FieldDevice;
}

export const FieldDeviceDeploymentRings: React.FC<FieldDeviceDeploymentRingsProps> = ({
  device
}) => {
  return (
    <>
      <SectionTitle>Device Deployment Rings</SectionTitle>

      <MessageBar messageBarType={MessageBarType.info}>
        Drag and drop rows to re-order the priority of the deployment rings for
        this device. The priority of the deployment rings may affect the
        resulting field configuration for this device.
      </MessageBar>

      <FieldDeviceDeploymentRingList device={device} />
    </>
  );
};
